import { cn } from "@/lib/utils";
import { useEffect, useRef, useState } from "react";

interface BarChartProps {
  percentage: number;
  variant?: "default" | "red";
  className?: string;
  delay?: number;
}

export const BarChart = ({ percentage, variant = "default", className, delay = 0 }: BarChartProps) => {
  const [animatedWidth, setAnimatedWidth] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated) {
            setHasAnimated(true);
            setTimeout(() => {
              setAnimatedWidth(percentage);
            }, delay);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [percentage, hasAnimated, delay]);

  return (
    <div ref={ref} className={cn("bar-track", className)}>
      <div 
        className={cn(
          variant === "red" ? "bar-fill-red" : "bar-fill",
          "transition-all duration-1000 ease-out"
        )} 
        style={{ width: `${animatedWidth}%` }} 
      />
    </div>
  );
};
